import { observer } from 'mobx-react-lite'
import React from 'react'
import { SMSMessageField } from 'widgets/MessageFormFields'
import { type SendSMSBlockStore } from 'widgets/Flow/blocks/SendSMS'
import { SendFromBlockActionEditContent } from 'widgets/Flow/blocks/SendFrom'
import styles from './styles.module.scss'

type IActionEditContentProps = {
  store: SendSMSBlockStore
}
export const SendSMSBlockActionEditContent = observer(({ store }: IActionEditContentProps) => {
  const { smsMessageFieldStore, smsError, sendFromBlockStore } = store
  return (
    <div className={styles.wrap}>
      <SendFromBlockActionEditContent store={sendFromBlockStore} />

      <SMSMessageField smsMessageFieldStore={smsMessageFieldStore} errorMessage={smsError} />
    </div>
  )
})
